module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Douglas Laycock\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("   "), _c('B', [_vm._v("Douglas Laycock")]), _vm._v(" is Robert E. Scott Distinguished Professor of Law and professor of religious studies at the University of Virginia. In addition to his work as a lawyer, he has written for the "), _c('I', [_vm._v("New York Times")]), _vm._v(", the "), _c('I', [_vm._v("Washington Post")]), _vm._v(", and numerous other publications. ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/GrOj06/tc-custom/9781467434294.jpg?1737196544353",
      "alt": "This image is the cover for the book Religious Liberty, Volume 2, Emory University Studies in Law and Religion (EUSLR)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Religious Liberty, Volume 2, Emory University Studies in Law and Religion (EUSLR)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("For more than thirty years, Douglas Laycock has been studying, defending, and writing about religious liberty. In this second volume of the comprehensive collection of his writings on the subject, he has compiled articles, amicus briefs, and actual court documents relating to regulatory exemptions under the Constitution, the right to church autonomy, and the rights of non-mainstream religions.  This collection — which deals with religious schools and colleges, sex abuse cases, the rights of Hare Krishnas and Scientologists, the landmark decision Employment Division v. Smith, and more — will be a valuable reference for churches, schools, and other religious organizations as they exercise their Constitutionally protected freedom of religion.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0